import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import { ContactResponses } from "@tfg/types/endpoints/contacts"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"
import { UpdateBusinessPartnerRequestDto } from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useUpdateBusinessPartnerMutation = (
  contactId: string,
  options?: UseMutationOptions<
    ContactResponses.Contact,
    AxiosError,
    UpdateBusinessPartnerRequestDto
  >
) => {
  const { t } = useTranslation("traceability")
  return useMutation({
    ...options,
    mutationFn: async (variables) => {
      return (
        await httpClient.put<ContactResponses.Contact>(
          `/v1/contacts/update-business-partner/${contactId}`,
          variables
        )
      ).data
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      showSuccessNotification({
        message: t("contactModal.messages.update.success", {
          email: variables.email,
        }),
        title: t("contactModal.messages.update.success", {
          email: variables.email,
        }),
      })
      await queryClient.invalidateQueries({
        queryKey: ["listContacts"],
      })
      showSuccessNotification()
    },
    onError: (error, variables, onMutateResult, context) => {
      showAxiosError({
        notificationMessage: t("contactModal.messages.update.error", {
          error: error.response?.data ?? error.message,
        }),
        showNotification: true,
        error,
      })
      options?.onError?.(error, variables, onMutateResult, context)
    },
  })
}
